import { createUseStyles } from "react-jss";

const styles = createUseStyles(theme => ({
  complianceTab: {

  },
}));

export default styles;
